import { cloneRequest } from "./cloneRequest";
import { GENERATED_HEADERS } from "./constants";
/**
 * @internal
 */
export function prepareRequest(request) {
    // Create a clone of the request object that does not clone the body
    request =
        typeof request.clone === "function"
            ? request.clone()
            : cloneRequest(request);
    for (var _i = 0, _a = Object.keys(request.headers); _i < _a.length; _i++) {
        var headerName = _a[_i];
        if (GENERATED_HEADERS.indexOf(headerName.toLowerCase()) > -1) {
            delete request.headers[headerName];
        }
    }
    return request;
}
//# sourceMappingURL=prepareRequest.js.map